import {
  maxLength,
  nonEmpty,
  object,
  pipe,
  regex,
  string,
  trim,
  url,
} from "valibot";

export const FlowNameSchema = object({
  name: pipe(
    string(),
    trim(),
    nonEmpty("Flow name is required"),
    maxLength(20, "Flow name can't be more than 20 characters long"),
  ),
});

export const UrlTargetingSchema = object({
  url: pipe(
    string(),
    nonEmpty("URL is required"),
    regex(
      /^https?:\/\/(www\.)?linkedin\.com\/search\/(.*)\/(.*)\?/,
      "The URL must be a valid LinkedIn search URL",
    ),
  ),
});

export const ProfileUrlSchema = object({
  url: pipe(string(), trim(), nonEmpty("Profile URL is required")),
});

export const NavigatorUrlSchema = object({
  url: pipe(
    string(),
    trim(),
    nonEmpty("Sales Navigator Search URL is required"),
    url("Enter a valid URL format (e.g., https://www.linkedin.com/sales/...)"),
  ),
});
